import {Presentation, PresentationState} from "../../../../core/gameflow/controller/Presentation";
import {GameData} from "../../../server/data/GameData";
import {PREngineManager} from "../../../punkEngine/PREngineManager";
import {PunkSymbol} from "../../../punkEngine/symbol/PunkSymbol";
import {ReelSymbolStates} from "../../../../core/reel/symbol/ReelSpriteSymbolArea";
import {SoundManager} from "../../../sound/SoundManager";
import {IBetWayWinData} from "../../../server/base/IData";
import {PREngineController} from "../../../punkEngine/PREngineController";
import {PunkRocker} from "../../../PunkRocker";
import {GameConfig} from "../../../config/base/GameConfig";

export class PipeBombPresentation extends Presentation {
    private _gameData: GameData;
    private _isXWildPresent: boolean = false;
    private _symSizes: number[][];

    setGamedData(data: GameData): void {
        this._gameData = data;

        this._symSizes = this._gameData.raw.symbolSizes;

        const reelsData: string[][] = this._gameData.raw.reels;

        for (let reelId: number = 0; reelId < reelsData.length; reelId++) {
            const currReelData: string[] = reelsData[reelId].slice(1, -1);

            for (let symId: number = 0; symId < currReelData.length; symId++) {
                const currSymName: string = currReelData[symId];

                if (currSymName === "XWILD") {
                    this._isXWildPresent = true;
                    break;
                }
            }

            if (this._isXWildPresent) {
                break;
            }
        }
    }

    createPresentation(enableSkip: Function) {
        if (this._isXWildPresent) {
            const delayBetweenSpinAndBlast: number = this.getTimeToStartAnimations();
            let wildNotOnTopRow: boolean = false,
                soundCtr: number = 1;
            const xWildExplodeSoundPlayedRowWise: boolean[] = [false, false, false];

            // #396
            GameConfig.xWILD_PRESENTATION_STARTED = true;

            this.timeline.add(() => {
                SoundManager.stopWildFuseSound();
            }, delayBetweenSpinAndBlast);//0.733 is animDurr from currSym!.playPipeBombAnimation

            PREngineManager.AllReels.forEach(currReel => {
                if (currReel.isActive) {
                    for (let i: number = 0; i < currReel.AllWindowSymbols.length; i++) {
                        const currSym: PunkSymbol = currReel.AllWindowSymbols[i];
                        if (currSym.isXWild) {
                            const currSymPosId: number = currSym.posID[0];
                            wildNotOnTopRow = (wildNotOnTopRow || (currSymPosId > 0));

                            this.timeline.add(currSym!.playPipeBombAnimation("explode", this._symSizes[currReel.reelID][currSymPosId], false), delayBetweenSpinAndBlast);
                            if (!xWildExplodeSoundPlayedRowWise[currSymPosId]) {
                                xWildExplodeSoundPlayedRowWise[currSymPosId] = true;
                                this.timeline.add(() => {
                                    SoundManager.playSoundEffect("xWildExplode" + soundCtr++);
                                }, delayBetweenSpinAndBlast);
                            }

                            let growDelay: number = 0.234;

                            for (let i: number = (currSymPosId - 1); i >= 0; i--) {
                                const prevSym: PunkSymbol | undefined = PREngineManager.getReel(currReel.reelID).getSymbol(i),
                                    growAndBlastDelay: number = delayBetweenSpinAndBlast + growDelay;

                                this.timeline.add(prevSym!.playPipeBombAnimation("growExplosion", this._symSizes[currReel.reelID][i], false), growAndBlastDelay);
                                if (!xWildExplodeSoundPlayedRowWise[i]) {
                                    xWildExplodeSoundPlayedRowWise[i] = true;
                                    this.timeline.add(() => {
                                        SoundManager.playSoundEffect("xWildExplode" + soundCtr++);
                                    }, growAndBlastDelay);
                                }

                                growDelay += growDelay;
                            }

                            break; // only 1 xWild is possible per reel.
                        }
                    }
                }
            });

            this.timeline.to(this, {
                duration: 0.1
            });
            this.timeline.add(() => {
                PREngineManager.AllReels.forEach(currReel => {
                    if (currReel.isActive) {
                        for (let i: number = 0; i < currReel.AllWindowSymbols.length; i++) {
                            const currSym: PunkSymbol = currReel.AllWindowSymbols[i];
                            if (currSym.isXWild) {
                                const currSymPosId: number = currSym.posID[0];

                                // #332
                                currSym!.playPipeBombAnimation("smoulderingLoop", this._symSizes[currReel.reelID][currSymPosId], true);

                                for (let i: number = (currSymPosId - 1); i >= 0; i--) {
                                    const prevSym: PunkSymbol | undefined = PREngineManager.getReel(currReel.reelID).getSymbol(i);

                                    // #332
                                    prevSym!.playPipeBombAnimation("smoulderingLoop", this._symSizes[currReel.reelID][i], true);

                                    prevSym!.changeState({
                                        state: ReelSymbolStates.NORMAL,
                                        sizeType: this._symSizes[currReel.reelID][prevSym!.posID[0]] + 3,
                                        duration: 0.001,
                                        sym: "XWILD",
                                        forceState: true,
                                        alpha: 0
                                    });
                                }

                                break; // only 1 xWild is possible per reel.
                            }
                        }
                    }
                });
            });

            // #319
            const gameSize: number[] = this._gameData.Reel.calculateMultiWaysValues(this._gameData.mode);
            this.timeline.add(PunkRocker.waysCounter.setValue(undefined, gameSize[5], 0.1));
        }

        this.timeline.add(() => {
            this.PresentationState.set(PresentationState.INACTIVE);

            this._isXWildPresent = false;
        });

        if (this.timeline.duration() === 0) {
            this.timeline.to(this, {
                duration: 0.001
            });
        }
    }

    private getTimeToStartAnimations(): number {
        let retVal: number = 0.7 + 0.4, // 0.7 is landing animation time and for 1 landingLoop cycle, animation tab time is 0.2
            betWayWins: IBetWayWinData[] = this._gameData.Win.betWayWins;

        if (!betWayWins.length) {
            retVal = 0.7;
        } else {
            let isLengthMoreThan4: boolean = false;
            for (let i: number = 0; i < betWayWins.length; i++) {
                const betWayWin: IBetWayWinData = betWayWins[i];
                if (betWayWin.length > 4) {
                    isLengthMoreThan4 = true;

                    break;
                }
            }

            if (!isLengthMoreThan4) {
                const lastReel: PREngineController = PREngineManager.AllReels[PREngineManager.AllReels.length - 1];
                for (let i: number = 0; i < lastReel.AllWindowSymbols.length; i++) {
                    const currSym: PunkSymbol = lastReel.AllWindowSymbols[i];
                    if (currSym.isXWild) {
                        retVal = 0.7;

                        break; // only 1 xWild is possible per reel.
                    }
                }
            }
        }

        return retVal;
    }
}